import * as React from "react";
import {
    Button,
    Menu,
    MenuItem,
    Box,
    Typography,
} from "@mui/material";
import { languagesMenu } from "../CountriesLayout/CountriesLayout";

import { useLangNavigate } from "../../../Localization/useLangNavigate";
import { useNavigate } from "react-router-dom";
import i18n from "../../../Localization/i18n";
import { useLanguage } from "../../../Localization/LanguageLayout";
import { setStorageLang } from "../../../Localization/routesLocalized";
import { fontLink } from "../../../base";
import { isResultPage, isResultSamplePage } from "../../../Providers/Result/getResultData";
import { useResult } from "../../../Providers/Result/ResultDataProvider";
import { useMobileMenu } from "../../MobileBar/MobileMenuProvider";

// AppBar
const bot_right_anchor = {
    vertical: 'bottom',
    horizontal: 'right',
};

const top_right_transform = {
    vertical: 'top',
    horizontal: 'right',
};
// Footer

const top_right_anchor = {
    vertical: 'top',
    horizontal: 'right',
};
const bot_right_transform = {
    vertical: 'bottom',
    horizontal: 'right',
};

const getCurrentLanguage = (lang) => {
    for (let i = 0; i < languagesMenu.length; i++) {
        if (languagesMenu[i].code === lang) {
            return languagesMenu[i];
        }
    }
    return languagesMenu[0];
}

export default function LanguageMenu({ footer = false, sx = {}, sxInside = {}, setOpenExtern, openExtern,
}) {
    // Do not useLangNavigate here
    const navigate = useNavigate();
    const langNavigate = useLangNavigate();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const language = useLanguage();

    // On sample result page - no language switching
    const { region = 'cs' } = useResult() || {};
    const blockLangChange = isResultSamplePage() || isResultPage(); // On result page

    const changeLanguage = (code) => {
        setStorageLang(code);
        i18n.changeLanguage(code).then((result) => {
            setTimeout(() => {
                window?.updateSvgBoxes();
                window?.updateAiAgentSvgBoxes();
            }, 0);
        });

        const restOfPath = window.location.pathname.split("/").slice(2).join("/");
        navigate(`/${code}/${restOfPath}`);
    }

    const getDefaultLang = () => {
        if (blockLangChange && region && language !== region) {
            changeLanguage(region);
        }
        return getCurrentLanguage(blockLangChange ? region : language);
    }

    const langPreset = getDefaultLang();

    const handleClick = (e) => {
        if (blockLangChange) return;

        if (setOpenExtern) {
            e.preventDefault();
            e.stopPropagation();
            setOpenExtern(!openExtern);
            return;
        }
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        if (setOpenExtern) {
            setOpenExtern(false);
            return;
        }
        setAnchorEl(null);
    };

    return (
        <Box sx={{ ...sx }}>
            <Box
                onClick={handleClick}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: "center",
                    cursor: blockLangChange ? 'default' : 'pointer',
                    py: '8px',
                    ...sxInside,
                }}
            >
                <Box
                    component="img"
                    src={langPreset.flag}
                    alt={langPreset.code}
                    sx={{
                        width: { xs: '22px', sm: '22px', md: '25px' },
                        height: { xs: '22px', sm: '22px', md: '25px' },
                        borderRadius: "50%",
                        objectFit: "cover",
                        border: footer ? 'none' : '1px solid #eee'
                    }}
                />
                <Typography sx={{ textTransform: 'uppercase', fontWeight: 700, ...fontLink, ml: '8px', color: footer ? 'white' : '#011949' }}>
                    {langPreset.code}
                </Typography>
            </Box>

            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                    sx: {
                        p: 1,
                        borderRadius: 3,
                    },
                }}
                anchorOrigin={footer ? top_right_anchor : bot_right_anchor}
                transformOrigin={footer ? bot_right_transform : top_right_transform}
            >
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: 1,
                    }}
                >
                    {languagesMenu.map((lang) => (
                        <MenuItem
                            key={lang.code}
                            onClick={(e) => {
                                if (langPreset.code !== lang.code) {
                                    changeLanguage(lang.code);
                                }
                                handleClose(e);
                            }}
                            sx={{
                                borderRadius: "10px",
                                alignItems: "center",
                                gap: 1.5,
                                py: 1.2,
                                '&:hover': {
                                    backgroundColor: '#F8F8FC',
                                },
                            }}
                        >
                            <Box
                                component="img"
                                src={lang.flag}
                                alt={lang.code}
                                sx={{
                                    width: '25px',
                                    height: '25px',

                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    border: '1px solid #eee'
                                }}
                            />

                            <Box>
                                <Typography fontWeight={600} sx={{ ...fontLink }}>
                                    {lang.label}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {lang.sub}
                                </Typography>
                            </Box>
                        </MenuItem>
                    ))}
                </Box>
            </Menu>
        </Box>
    );
}
